import { type WorkplaceProfileResponse } from "@clipboard-health/contract-backend-main";
import { isDefined } from "@clipboard-health/util-ts";
import { type UseGetQueryOptions } from "@src/appV2/api/useGetQuery";
import { useGetWorkplace } from "@src/appV2/FacilityProfile/api/useGetWorkplace";

export function useGetChartingRecallSettings(params: {
  workplaceId: string | undefined;
  options?: UseGetQueryOptions<WorkplaceProfileResponse> & {
    customHeaders?: { Authorization: string };
  };
}) {
  const { workplaceId, options = {} } = params;
  const { enabled = true } = options;
  const {
    data: workplaceResponse,
    isLoading,
    isSuccess,
  } = useGetWorkplace({ workplaceId }, { ...options, enabled: enabled && isDefined(workplaceId) });
  const chartingRecall = workplaceResponse?.data.attributes.chartingRecall ?? {
    enabled: false,
    recallGracePeriodDurationInHours: 72,
  };
  return {
    chartingRecallEnabled: chartingRecall.enabled,
    recallGracePeriodDurationInHours: chartingRecall.recallGracePeriodDurationInHours,
    isLoading,
    isSuccess,
  };
}
